<template>
  <div class="sp-template tms-index__page">
    <el-row class="m-t-20" :gutter="20">
      <!-- 系统公告 -->
      <el-col :span="8">
        <el-card>
          <div slot="header" class="clearfix">
            <span class="h2">系统公告</span>
            <span class="tips-text">(共
              <b class="number">{{noticeTotal}}</b>条，其中
              <router-link class="new" tag="a" :to="{path:'/bulletin',query:{status:3}}" title="点击查看未读公告">未读公告</router-link>
              <b class="number">{{unreadNoticeTotal}}</b>条)
            </span>
            <router-link style="float: right; color: #409EFF;" tag="a" :to="{path:'/bulletin',query:{status:1}}">查看全部 >></router-link>
          </div>
          <ul class="news-list">
            <a href="#" v-for="item in unreadNoticeList" :key="item.id" @click.prevent="checkNoticeInfo('NOTICE',item)" :class="[item.isRead ? 'has-read' : 'not-read']">
              <li class="list">
                <img src="../../../static/img/new.gif" class="new-gif__icon" alt="" />
                <span class="item-title">{{item.title}}</span>
                <small class="small">{{item.createDate}}</small>
              </li>
            </a>
            <a href="#" v-for="item in readNoticeList" :key="item.id" @click.prevent="checkNoticeInfo('NOTICE',item)" :class="[item.isRead ? 'has-read' : 'not-read']">
              <li class="list">
                <span class="item-title">{{item.title}}</span>
                <small class="small">{{item.createDate}}</small>
              </li>
            </a>
          </ul>
        </el-card>
      </el-col>

      <!-- 最新消息 -->
      <el-col :span="8">
        <el-card>
          <div slot="header" class="clearfix">
            <span class="h2">最新消息</span>
            <span class="tips-text">(共
              <b class="number">{{messageTotal}}</b>条，其中
              <router-link class="new" tag="a" :to="{path:'/message',query:{status:3}}" title="点击查看未读消息">未读消息</router-link>
              <b class="number">{{unreadMessageTotal}}</b>条)
            </span>
            <router-link style="float: right; color: #409EFF;" tag="a" :to="{path:'/message',query:{status:1}}">查看全部 >></router-link>
          </div>
          <ul class="news-list">
            <a href="#" v-for="item in unreadMessageList" :key="item.id" @click.prevent="checkNoticeInfo('MESSAGE',item)" :class="[item.isRead ? 'has-read' : 'not-read']">
              <li class="list">
                <!-- <i class="new-gif__icon"></i> -->
                <img src="../../../static/img/new.gif" class="new-gif__icon" alt="" />
                <span class="item-title">{{item.title}}</span>
                <small class="small">{{item.createDate}}</small>
              </li>
            </a>
            <a href="#" v-for="item in readMessageList" :key="item.id" @click.prevent="checkNoticeInfo('MESSAGE',item)" :class="[item.isRead ? 'has-read' : 'not-read']">
              <li class="list">
                <span class="item-title">{{item.title}}</span>
                <small class="small">{{item.createDate}}</small>
              </li>
            </a>
          </ul>
        </el-card>
      </el-col>
      <!-- 更新报价 -->
      <el-col :span="8">
        <el-card>
          <div slot="header" class="clearfix">
            <span class="h2">更新报价</span>
            <span class="tips-text">(共
              <b class="number">{{quotationTotal}}</b>条，其中
              <router-link class="new" tag="a" :to="{path:'/quotation',query:{status:3}}" title="点击查看最新报价">最新报价</router-link>
              <b class="number">{{unreadQuotationTotal}}</b>条)
            </span>
            <router-link style="float: right; color: #409EFF;" tag="a" :to="{path:'/quotation',query:{status:1}}">查看全部 >></router-link>
          </div>
          <ul class="news-list">
            <a href="#" v-for="item in unreadQuotationList" :key="item.id" @click.prevent="checkNoticeInfo('QUOTATION',item)" :class="[item.isRead ? 'has-read' : 'not-read']">
              <li class="list update-price__list">
                <img src="../../../static/img/new.gif" class="new-gif__icon" alt="" />
                <span class="item-title">{{item.title}}</span>
                <i class="iconfont icon-xiazai download-file__btn" title="下载" @click.stop="quotationDownload(item.quotationNoticeValues[0].quotationUrl)"></i>
                <small class="small">{{item.createDate}}</small>
              </li>
            </a>
            <a href="#" v-for="item in readQuotationList" :key="item.id" @click.prevent="checkNoticeInfo('QUOTATION',item)" :class="[item.isRead ? 'has-read' : 'not-read']">
              <li class="list update-price__list">
                <span class="item-title">{{item.title}}</span>
                 <i class="iconfont icon-xiazai download-file__btn" title="下载" @click.stop="quotationDownload(item.quotationNoticeValues[0].quotationUrl)"></i>
                <small class="small">{{item.createDate}}</small>
              </li>
            </a>
          </ul>
        </el-card>
      </el-col>
    </el-row>

    <el-row class="m-t-20" :gutter="20">
      <el-col :span="8">
        <el-card>
          <div slot="header" class="clearfix">
            <span class="h2">系统信息</span>
            <span class="tips-text">(共
              <b class="number">{{systemInfoTotal}}</b>条，其中
              <router-link class="new" tag="a" :to="{path:'/systeminfo',query:{status:3}}" title="点击查看未读公告">未读系统信息</router-link>
              <b class="number">{{unreadSystemInfoTotal}}</b>条)
            </span>
            <router-link style="float: right; color: #409EFF;" tag="a" :to="{path:'/systeminfo',query:{status:1}}">查看全部 >></router-link>
          </div>
          <ul class="news-list">
            <a href="#" v-for="item in unreadSystemInfoList" :key="item.id" @click.prevent="checkNoticeInfo('NOTICE',item)" :class="[item.isRead ? 'has-read' : 'not-read']">
              <li class="list">
                <img src="../../../static/img/new.gif" class="new-gif__icon" alt="" />
                <span class="item-title">{{item.title}}</span>
                <small class="small">{{item.createDate}}</small>
              </li>
            </a>
            <a href="#" v-for="item in readSystemInfoList" :key="item.id" @click.prevent="checkNoticeInfo('NOTICE',item)" :class="[item.isRead ? 'has-read' : 'not-read']">
              <li class="list">
                <span class="item-title">{{item.title}}</span>
                <small class="small">{{item.createDate}}</small>
              </li>
            </a>
          </ul>
        </el-card>
      </el-col>

    </el-row>
    <!-- 通知-弹层 -->
    <el-dialog :title="title" :visible.sync="dialogNoticeVisible" append-to-body width="30%">
      <div class="dialog-content">
        <span class="title">标题：</span>
        <span class="content">{{checkNotice.title}}</span>
      </div>
      <div class="dialog-content">
        <span class="title">优先级：</span>
        <span class="content">{{checkNotice.level == 1 ? "紧急" : "一般"}}</span>
      </div>
      <div class="dialog-content">
        <span class="title">发布公司：</span>
        <span class="content">{{checkNotice.orgOp}}</span>
      </div>
      <div class="dialog-content" v-if="checkNotice.quotationNoticeValues && checkNotice.quotationNoticeValues.length > 0">
        <span class="title">最新报价：</span>
        <span class="content">
          <a 
            class="content-price__download"
            :href="item.quotationUrl" 
            v-for="(item, index) in checkNotice.quotationNoticeValues" 
            :key="index"
            title="点击下载报价单">
            {{customerTypeMap[item.customerType]}}
          </a>
        </span>
      </div>
      <div class="dialog-content">
        <span class="title">发布时间：</span>
        <span class="content">{{checkNotice.createDate}}</span>
      </div>
      <div class="dialog-content">
        <span class="title">内容：</span>
        <span class="content text-content ql-editor" v-html="checkNotice.content"></span>
      </div>
    </el-dialog>
    <!-- 紧急通知-弹层 -->
    <el-dialog title="紧急通知" :visible.sync="dialogUrgentVisible" append-to-body width="30%" :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false" center>
      <div class="dialog-content">
        <span class="title">标题：</span>
        <span class="content">{{noticeData[0].title}}</span>
      </div>
      <div class="dialog-content">
        <span class="title">类型：</span>
        <span class="content">{{noticeData[0].type == "NOTICE" ? "系统公告" : "最新消息"}}</span>
      </div>
      <div class="dialog-content">
        <span class="title">发布公司：</span>
        <span class="content">{{noticeData[0].orgOp}}</span>
      </div>
      <div class="dialog-content" v-if="noticeData[0].quotationNoticeValues && noticeData[0].quotationNoticeValues.length > 0">
        <span class="title">最新报价：</span>
        <span class="content">
          <a 
            class="content-price__download"
            :href="item.quotationUrl" 
            v-for="(item, index) in noticeData[0].quotationNoticeValues" 
            :key="index"
            title="点击下载报价单">
            {{customerTypeMap[item.customerType]}}
          </a>
        </span>
      </div>
      <div class="dialog-content">
        <span class="title">发布时间：</span>
        <span class="content">{{noticeData[0].createDate}}</span>
      </div>
      <div class="dialog-content">
        <span class="title">内容：</span>
        <span class="content text-content" v-html="noticeData[0].content"></span>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="createdReadNotice(noticeData[0].id,'URGENT_NOTICE')">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 认领 -->
    <el-row class="m-t-20" :gutter="20">
      <el-col>
        <el-card>
          <div slot="header" class="clearfix">
            <span class="h2">认领</span>
          </div>
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <el-form :inline="true" :model="searchData" class="demo-form-inline" size="small">
                <el-form-item label="开始日期">
                  <el-date-picker v-model.lazy="searchData.startDate" type="date" value-format="yyyy-MM-dd" placeholder="开始日期"></el-date-picker>
                </el-form-item>
                <el-form-item label="结束日期">
                  <el-date-picker v-model.lazy="searchData.endDate" type="date" value-format="yyyy-MM-dd" placeholder="结束日期"></el-date-picker>
                </el-form-item>
                <el-form-item>
                  <el-button v-if="in_configs(101)" type="primary" @click="onSubmit">搜索</el-button>
                </el-form-item>
              </el-form>
            </div>
            <el-table :data="tableData" tooltip-effect="dark" border style="width: 100%" @selection-change="handleSelectionChange">
              <el-table-column type="selection" width="55"></el-table-column>
              <el-table-column prop="expressCompany" label="快递公司"></el-table-column>
              <el-table-column prop="qty" label="到货箱数"></el-table-column>
              <el-table-column prop="weight" label="重量(kg)"></el-table-column>
              <el-table-column prop="name" label="图片">
                <template slot-scope="scope">
                  <sp-img :url-arr="scope.row.imgUrl" :show-one="true"></sp-img>
                </template>
              </el-table-column>
              <el-table-column prop="createDate" label="创建时间"></el-table-column>
              <el-table-column label="认领">
                <template slot-scope="scope">
                  <el-button v-if="in_configs(102)" size="small" class="btn-cyan" @click="showClaimWindow(scope.row)">认领</el-button>
                </template>
              </el-table-column>
            </el-table>
            <!-- 分页 -->
            <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="searchData.currentPage" :page-sizes="[100, 200, 300, 400]" :page-size="100" layout="total, sizes, prev, pager, next, jumper" :total="total">
            </el-pagination>
            <!-- 弹窗 -->
            <el-dialog title="新建认领单" :visible.sync="dialogFormVisible" customClass="pickUpModel">
              <el-form :model="form" size="small" :rules="formRule" ref="form">
                <el-form-item label="快递单号" label-width="120px" prop="expressCode">
                  <el-input v-model="form.expressCode" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="认领箱号" label-width="120px" prop="cartonCodeTags">
                  <el-tag :key="tag" v-for="tag in form.cartonCodeTags" closable :disable-transitions="false" @close="handleClose(tag)">
                    {{tag}}
                  </el-tag>
                  <el-input class="input-new-tag" v-if="inputVisible" v-model="inputValue" ref="saveTagInput" size="small" @keyup.enter.native="handleInputConfirm" @blur="handleInputConfirm">
                  </el-input>
                  <span  v-else><el-button class="button-new-tag" size="small" @click="showInput">添加箱号</el-button></span>
                </el-form-item>
                <el-form-item label="产品" label-width="120px" prop="product">
                    <el-select v-model="form.product">
                        <el-option v-for="(p,i) in channelData" :key="i" :label="p.nameCN" :value="p.id"   ></el-option>
                    </el-select>
                </el-form-item>
              </el-form>
              <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="dialogFormVisible = false">取 消</el-button>
                <el-button size="small" type="primary" @click="saveClaim()">确 定</el-button>
              </div>
            </el-dialog>
          </el-card>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>
<script>
export default {
  data() {
    return {
      title:"",
      dateTime: "",
      week: "",
      loginInfo: {},
      orgName: "",
      userName: "",
      customerNumber: "",
      noticeData: [
        {
          content: "",
          createDate: "",
          id: "",
          level: 1,
          orgOp: "",
          title: "",
          type: "",
          isRead: false
        }
      ],
      flag: false,
      currentPage: 1,
      pageSize: 10,
      status: 2,
      systemInfoTotal:0,
      unreadSystemInfoTotal:0,
      unreadSystemInfoList:[],
      readSystemInfoList:[],
      noticeTotal: 0,
      unreadNoticeTotal: 0,
      unreadNoticeList: [],
      readNoticeList: [],
      messageTotal: 0,
      unreadMessageTotal: 0,
      unreadMessageList: [],
      readMessageList: [],
      quotationTotal: 0,
      unreadQuotationTotal: 0,
      unreadQuotationList: [],
      readQuotationList: [],
      checkNotice: "",
      dialogNoticeVisible: false,
      dialogUrgentVisible: false,
      //搜索数据
      searchData: {
        expressCode: "",
        currentPage: 1,
        pageSize: 100,
        startDate: "",
        endDate: ""
      },
      //表单数据
      tableData: [
        {
          name: "",
          src: [],
          arr: [
            {
              test: ""
            }
          ]
        }
      ],
      total: 0,
      warehouseData: [],
      warehouseDataMap: {},
      multipleSelection: [], //表单选中的列
      //新建弹窗
      dialogFormVisible: false,
      form: {
        warehouseId: "",
        expressCompany: "",
        expressCode: "",
        qty: "",
        cartonCodeTags: [],
        weight: ""
      },
      channelData: [],
      channelDataMap: {},
      imgFile: [],
      formRule: {
        expressCode: [
          {
            required: true,
            message: "请填写快递单号",
            trigger: "blur"
          }
        ],
        cartonCodeTags: [
          {
            required: true,
            message: "请填写箱号",
            trigger: "blur"
          }
        ],
        product: [
          {
            required: true,
            message: "请选择产品",
            trigger: "change"
          }
        ]
      },
      customerTypeList: [],
      customerTypeMap: {},
      claimRow: {},
      addImg: "",
      inputVisible: false,
      inputValue: "",
      //上传图片
      dialogImageUrl: "",
      dialogVisible: false,
    };
  },
  components: {},
  created() {
    setTimeout(() => {
      let currentOrg = sessionStorage.getItem("currentOrg");
      if (currentOrg !== undefined && currentOrg !== null) {
        this.getCustomerType()
        this.queryUrgentNotice();
        this.queryNotice();
        this.queryMessage();
        this.querySystemInfo();
        this.queryQuotationNotice();
      }
      this.loadChannel();
      this.onSubmit();
    }, 600);
  },
  mounted: function() {
    var _this = this;
    this.$nextTick(function() {});
  },
  methods: {
    // 获取客户类型
    getCustomerType() {
      this.$request1.get(
        '/notice/queryCustomerType'
      ).then(res => {
        if(res.data && res.data.length > 0) {
          this.customerTypeList = res.data
          this.customerTypeList.forEach(item => {
            this.customerTypeMap[item.value] = item.name
          })
        }
      }).catch(err => {
        console.log(err)
      })
    },
    quotationDownload(url) {
      this.$windowOpen1(url)
    },
    queryUrgentNotice() {
      this.$request1({
        method: 'GET',
        url: '/notice/urgent'
      })
        .then(response => {
          console.log(response.data);
          this.noticeData = response.data;
          if (this.noticeData.length > 0) {
            this.dialogUrgentVisible = true;
          } else {
            this.noticeData = [
              {
                content: "",
                createDate: "",
                id: "",
                level: 1,
                orgOp: "",
                title: "",
                type: ""
              }
            ];
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    //搜索
    onSubmit() {
      let _this = this;
      _this.$request1
        .post(
          '/claim/query',
          {
              id: "",
              warehouseId: "",
              expressCompany: "",
              expressCode: _this.searchData.expressCode,
              orderId: "",
              claimed: false,
              startDate: _this.searchData.startDate,
              endDate: _this.searchData.endDate,
              currentPage: _this.searchData.currentPage,
              pageSize: _this.searchData.pageSize
            },
          {
            withCredentials: true
          }
        )
        .then(function(res) {
          console.log(res);
          if (res.data.success) {
            _this.tableData = res.data.data;
            _this.total = res.data.total;
          } else {
            _this.$message.error(res.data.message);
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    showClaimWindow(row) {
      console.log(row);
      let _this = this;
      _this.claimRow = row;
      _this.dialogFormVisible = true;
    },
    loadChannel() {
      let _this = this;
      this.$request1({
        method: 'GET',
        url: '/channel'
      })
        .then(response => {
          if (response.data.data && response.data.data.length > 0) {
            this.channelData = response.data.data;
            this.channelData.forEach((d, i) => {
              this.channelDataMap[d.id] = d.nameCN;
            });
          } else {
            this.channelData = [];
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    saveClaim() {
      let _this = this;
      let _valid = true;
      console.log(_this.form);
      _this.$refs["form"].validate(valid => {
        if (!valid) {
          _valid = false;
        }
      });
      if (!_valid) {
        return false;
      }
      let _old = _this.claimRow.cartonCodes
        .split(",")
        .sort()
        .toString();
      let _new = _this.form.cartonCodeTags.sort().toString();
      if (
        _this.form.expressCode != _this.claimRow.expressCode ||
        _old != _new
      ) {
        this.$message.error("箱号或快递单号填写错误");
        return false;
      }

      this.$router.push(
        "/neworder?product=" +
          _this.form.product +
          "&claim=" +
          _this.claimRow.id
      );

      return false;
    },
    selectShippingAddress(id) {
      this.shippingList.forEach((d, i) => {
        if (d.id == id) {
          this.shippingId = id;
          this.form.deliveryDetail.province = d.province;
          this.form.deliveryDetail.city = d.city;
          this.form.deliveryDetail.addressFirst = d.address;
          this.form.deliveryDetail.contractName = d.name;
          this.form.deliveryDetail.phone = d.phone;
        }
      });
    },
    queryNotice() {
      this.$request1({
        method: 'GET',
        url: '/notice/notice',
        params: {
          currentPage: this.currentPage,
          pageSize: this.pageSize,
          status: this.status
        }
      })
        .then(response => {
          console.log(response.data);
          this.noticeTotal = response.data.total;
          this.unreadNoticeTotal = response.data.data.unreadTotal;
          this.unreadNoticeList = response.data.data.unread;
          this.readNoticeList = response.data.data.read;
        })
        .catch(error => {
          console.log(error);
        });
    },
    queryMessage() {
      this.$request1({
        method: 'GET',
        url: '/notice/message',
        params: {
          currentPage: this.currentPage,
          pageSize: this.pageSize,
          status: this.status
        }
      })
        .then(response => {
          console.log(response.data);
          this.messageTotal = response.data.total;
          this.unreadMessageTotal = response.data.data.unreadTotal;
          this.unreadMessageList = response.data.data.unread;
          this.readMessageList = response.data.data.read;
        })
        .catch(error => {
          console.log(error);
        });
    },

   querySystemInfo() {
      this.$request1({
        method: 'GET',
        url: '/notice/systemInfo',
        params: {
          currentPage: this.currentPage,
          pageSize: this.pageSize,
          status: this.status
        }
      })
        .then(response => {
          console.log(response)
              this.systemInfoTotal = response.data.total;
              this.unreadSystemInfoTotal = response.data.data.unreadTotal;
              this.unreadSystemInfoList = response.data.data.unread;
              this.readSystemInfoList = response.data.data.read;
        })
        .catch(error => {
          console.log(error);
        });
    },

    queryQuotationNotice() {
      this.$request1({
        method: 'GET',
        url: '/notice/quotation',
        params: {
          currentPage: this.currentPage,
          pageSize: this.pageSize,
          status: this.status
        }
      })
        .then(response => {
          console.log(response.data);
          this.quotationTotal = response.data.total;
          this.unreadQuotationTotal = response.data.data.unreadTotal;
          this.unreadQuotationList = response.data.data.unread;
          this.readQuotationList = response.data.data.read;
        })
        .catch(error => {
          console.log(error);
        });
    },

    checkNoticeInfo(type, data) {
      console.log(data);
      this.title = "系统公告";
      if (type == "MESSAGE") {
        this.title = "最新消息";
      } else if (type == "QUOTATION") {
        this.title = "更新报价";
      } else if(type == "SYSTEMINFO"){
        this.title = "系统信息";
      }
      this.checkNotice = data;
      this.dialogNoticeVisible = true;
      if (!data.isRead) {
        this.createdReadNotice(data.id, type);
      }
    },
    createdReadNotice(noticeId, type) {
      this.$request1({
        method: 'POST',
        url: '/readNotice/create',
        params: {
          noticeId: noticeId
        }
      })
        .then(response => {
          console.log(response.data);
          this.dialogUrgentVisible = false;
          if (type == "MESSAGE") {
            this.queryMessage();
          } else if (type == "QUOTATION") {
            this.queryQuotationNotice();
          } else if (type == "NOTICE"){
            this.queryNotice();
          }else {
            this.querySystemInfo();
            this.queryUrgentNotice();
            this.queryNotice();
            this.queryMessage();
            this.queryQuotationNotice();
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    imgChange(file, fileList) {
      this.addImg = file.raw;
    },
    //表格多选按钮
    handleSelectionChange(val) {
      this.multipleSelection = val;
      console.log(this.multipleSelection);
    },
    //上传图片
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    //标签
    handleClose(tag) {
      this.form.cartonCodeTags.splice(this.form.cartonCodeTags.indexOf(tag), 1);
    },
    showInput() {
      this.inputVisible = true;
      this.$nextTick(_ => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },
    handleInputConfirm() {
      let inputValue = this.inputValue;
      if (inputValue) {
        this.form.cartonCodeTags.push(inputValue);
      }
      this.inputVisible = false;
      this.inputValue = "";
    },
    //分页
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.searchData.pageSize = val;
      this.onSubmit();
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.searchData.currentPage = val;
      this.onSubmit();
    }
  }
};
</script>
<style lang="scss">
.tms-index__page {
  .box-card {
    h2 {
      font-weight: normal;
    }
    span {
      display: inline-block;
    }
    .m-t {
      margin-top: 56px;
      margin-bottom: 40px;
    }
  }
  .f-box {
    margin-bottom: 20px;
  }
  //新闻
  .news-list {
    > a {
      //height: 40px;
      position: relative;
      display: block;
      width: 100%;
      padding: 15px 0 15px 25px;
      border-top: 1px solid #ebeef5;
      &:first-child {
        border-top: none;
      }
      &.has-read {
        .item-title,
        .small {
          color: #676767;
        }
      }
      &.not-read {
        .item-title,
        .small {
          color: rgb(34, 34, 34);
          font-weight: 700;
        }
      }
      .download-file__btn {
        float: left;
        margin: 0 10px;
        z-index: 99;
      }
      .update-price__list {
        .item-title {
          float: left;
        }
      }
    }
    .small {
      float: right;
      color: #888;
      font-size: 12px;
    }
    .new-gif__icon {
      position: absolute;
      top: 15px;
      left: -10px;
    }
  }
  .clearfix {
    .h2 {
      font-size: 16px;
      font-weight: bold;
      color: #666;
    }
  }
  .tips-text {
    margin-left: 10px;
    font-size: 12px;
    .number {
      margin: 0 5px;
      font-weight: 400;
    }
    .new {
      margin-left: 5px;
      color: #5fa207;
      &:link,
      &:hover,
      &:visited {
        color: #5fa207;
      }
      &:hover {
        text-decoration: underline;
      }
    }
  }
  .pickUpModel {
    width: 500px;
    .el-select {
      width: 100%;
    }
  }
}

.update-price__list:after {
  content: "";
  display: block;
  clear: both;
}

.content-price__download {
  margin-right: 15px;
  color: rgb(64, 158, 255);
  &:hover {
    text-decoration: underline;
  }
}

@media (min-width: 768px) {
}
@media (min-width: 992px) {
}
</style>


// WEBPACK FOOTER //
// src/views/home/index.vue